/* eslint-disable react/no-unused-class-component-methods */
'use strict';

import React, { Component } from 'react'

import Layout from '@Layout/FrontOffice'

import { handleChange } from '@/Form/Functions/eventsHandling'
import getFormStatus    from '@/Form/Functions/getFormStatus'
import getFormData      from '@/Form/Functions/getFormData'

import FormElement from '@/Form/toolkit/FormElement'

import LinkedinIcon from '@/Icons/Linkedin'

import Message from '@Pure/Message'
import Loader  from '@Pure/Loader'

const { app, qwest, moment } = window;

let months_config = [];

months_config.length = 12;

months_config = Array.from(months_config).map(function (empty, i)
{
	return { value: String(i), label: moment().month(i).format('MMMM') };
});

export default class PartnersRenewalPage extends Component
{
	state =
	{
		loading: true,

		year: moment().format('YYYY'),
		next_year: moment().add(1, 'year').format('YYYY'),

		form_data: { },
		status_messages: { },
		update_status: { },

		continue: false,
		stopping: false,
		updating: false
	};

	handleChange = (e, data) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState({ update_status: { } });

		handleChange.bind(this)(e, data);
	}

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.resetFunctions();

		component.verifyToken();
	}

	verifyToken = () =>
	{
		const component = this, props = this.props, state = this.state;

		const token = document.location.pathname
		.slice(document.location.pathname.lastIndexOf('/') + 1);

		qwest.post('/partner-renewal/verify-token',
		{
			token: token
		})
		.then(function (xhr, response)
		{
			component.setState(
			{
				loading: false,
				partner: response.partner
			});
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			component.setState(
			{
				error: response.error || 'Le lien utilisé est invalide.',
				loading: false
			});
		});
	}

	stopRenewal = () =>
	{
		const component = this, props = this.props, state = this.state;

		if (state.stopping === true) return;

		component.setState({ stopping: true });

		const token = document.location.pathname
		.slice(document.location.pathname.lastIndexOf('/') + 1);

		qwest.post('/partner-renewal/stop',
		{
			token: token
		})
		.then(function (xhr, response)
		{
			component.setState(
			{
				stopping: false,
				stopped: true,

				info: 'Nous avons bien pris en compte votre souhait ' +
					'de ne pas renouveler votre partenariat.'
			});
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			component.setState(
			{
				error: response.error || 'Le lien utilisé est invalide.',
				stopping: false
			});
		});
	}

	validate = () =>
	{
		const component = this, props = this.props, state = this.state;

		if (state.updating === true) return;

		component.setState({ updating: true });

		let form_data = new FormData();

		const token = document.location.pathname
		.slice(document.location.pathname.lastIndexOf('/') + 1);

		form_data.append('token', token);

		form_data = getFormData(
		{
			form_data: form_data,
			state: state.form_data
		});

		qwest.post('/partner-renewal/confirmation', form_data)
		.then(function (xhr, response)
		{
			component.setState(
			{
				updating: false,
				renewed: true,

				update_status: { },

				info: 'Merci, les informations ont été envoyées avec succès.',
				error: undefined,
				warning: undefined,
				statement: undefined
			});
		})
		.catch(function (error, xhr, response)
		{
			console.error(response?.error || response?.raw || error);

			component.setState(
			{
				updating: false,
				renewed: false,

				update_status: { error: response?.error },

				status_messages: response?.fields || { }
			});
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const loader = state.loading === true ?
		(
			<Loader className="c-loader" bemit={ ['primary', 'bg-white'] } />
		)
		: undefined;

		let output =
		(
			<Layout page_title="Renouvellement partenaire" public-front>

				<div className="u-table u-full-width"
					style={ { 'minHeight': '100%' } }>

					<div className="u-table-row">

						<div className="u-table-cell u-vertical-align-middle">

							<div className="partners-renewal">

								<div className="c-title">

									<div className="c-title__txt">
										Renouvellement de votre partenariat
									</div>

								</div>

								<div className="partners-renewal__content">

									<div className="o-content">
										{ getFormStatus(state) }
									</div>

									{
										state.partner?.id && !state.renewed &&
										state.stopped !== true
										? component.getRenewalFields()
										: undefined
									}

								</div>

								{ loader }

							</div>

						</div>

					</div>

				</div>

			</Layout>
		);

		return output;
	}

	initiateCanceling = () =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			canceling_confirmation: true
		});
	}

	resetStep = () =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			canceling_confirmation: false
		});
	}

	getRenewalFields = () =>
	{
		const component = this, props = this.props, state = this.state;

		const update_infos =
		(
			<div className="o-content">

				<div className="partners-renewal__actions">

					<div className="partners-renewal__actions-title">
						Modifications à apporter&nbsp;?
					</div>

					<div className="partners-renewal__actions-choices">

						<FormElement className="c-form-element
							c-form-element--inline"
							name="update-infos" type="radio"
							data={ state.form_data }
							label="Oui"
							status={ state.status_messages }
							onChange={ component.handleChange }
							radio_value="yes"
						/>

						<FormElement className="c-form-element
							c-form-element--inline"
							name="update-infos" type="radio"
							data={ state.form_data }
							label="Non"
							status={ state.status_messages }
							onChange={ component.handleChange }
							radio_value="no"
						/>

					</div>

					{
						state.form_data['update-infos'] === 'yes' ?
						(
							<FormElement className="c-form-element"
								name="update-infos-comment" type="textarea"
								data={ state.form_data }
								label="Commentaire"
								status={ state.status_messages }
								onChange={ component.handleChange }
							/>
						)
						: undefined
					}

				</div>

			</div>
		);

		const parts_3_4 =
		(
			<div className="o-grid-2 u-margin-top-15">

				<div className="o-grid__item">

					<p className="partners-renewal__title">
						3. Cette offre est cumulable avec soldes ou promotions&nbsp;:
					</p>

					<div className="partners-renewal__actions-choices">

						<FormElement className="c-form-element
							c-form-element--inline"
							name="stackable" type="radio"
							data={ state.form_data }
							label="Oui"
							status={ state.status_messages }
							onChange={ component.handleChange }
							radio_value="yes"
						/>

						<FormElement className="c-form-element
							c-form-element--inline"
							name="stackable" type="radio"
							data={ state.form_data }
							label="Non"
							status={ state.status_messages }
							onChange={ component.handleChange }
							radio_value="no"
						/>

					</div>

				</div>

			</div>
		);

		const discount_part =
		(
			<div className="o-content">

				<p className="partners-renewal__title">
					2. Vérification de l'Offre (Remise) consentie&nbsp;:
				</p>

				<div className="partners-renewal__infos">

					<span className="c-rendered-text"
						dangerouslySetInnerHTML={
							{ __html: state.partner.discount_infos || '-' } }
					/>

				</div>

				<div className="partners-renewal__actions">

					<div className="partners-renewal__actions-title">
						Modifications à apporter&nbsp;?
					</div>

					<div className="partners-renewal__actions-choices">

						<FormElement className="c-form-element
							c-form-element--inline"
							name="discount" type="radio"
							data={ state.form_data }
							label="Oui"
							status={ state.status_messages }
							onChange={ component.handleChange }
							radio_value="yes"
						/>

						<FormElement className="c-form-element
							c-form-element--inline"
							name="discount" type="radio"
							data={ state.form_data }
							label="Non"
							status={ state.status_messages }
							onChange={ component.handleChange }
							radio_value="no"
						/>

					</div>

					{
						state.form_data['discount'] === 'yes' ?
						(
							<FormElement className="c-form-element"
								name="discount-comment" type="textarea"
								data={ state.form_data }
								label="Commentaire"
								status={ state.status_messages }
								onChange={ component.handleChange }
							/>
						)
						: undefined
					}

				</div>

			</div>
		);

		const confirmation_cbs =
		(
			<div className="o-content u-margin-top-20">

				<FormElement className="c-form-element
					c-form-element--checkbox-right u-margin-top-5"
					name="stickers" type="checkbox"
					data={ state.form_data }
					label="Je m'engage à apposer les autocollants fournis gracieusement par Synergies (Caisse & Vitrine)."
					status={ state.status_messages }
					onChange={ component.handleChange }
				/>

				<FormElement className="c-form-element
					c-form-element--checkbox-right u-margin-top-5"
					name="pledge" type="checkbox"
					data={ state.form_data }
					label="Je m'engage à appliquer ces avantages sur présentation de la carte SYNERGIES en cours de validité (version papier et version électronique)."
					status={ state.status_messages }
					onChange={ component.handleChange }
				/>

				<div className="u-flex u-flex-wrap u-items-center">

					<FormElement className="c-form-element
						c-form-element--checkbox-right u-margin-top-5 u-margin-right-10"
						name="cgv" type="checkbox"
						data={ state.form_data }
						label="Je certifie avoir pris connaissance des CGV de Partenariats SYNERGIES."
						status={ state.status_messages }
						onChange={ component.handleChange }
					/>

					<a href="/documents/CG_partenariat.pdf" target="_blank"
						style={ { marginBottom: 7 } }>
						Voir les CG
					</a>

				</div>

			</div>
		);

		const loader = state.updating === true ?
		(
			<Loader className="c-loader" bemit={ ['white', 'bg-primary'] } />
		)
		: undefined;

		const cancel_loader = state.stopping === true ?
		(
			<Loader className="c-loader" bemit={ ['white', 'bg-primary'] } />
		)
		: undefined;

		if (state.canceling_confirmation)
		{
			return (
				<div className="partners-renewal__fields">

					<div className="o-content">

						<Message color="orange">
							Veuillez confirmer que vous ne souhaitez pas renouveler.
						</Message>

						<div className="partners-renewal__btns">

							<button type="button"
								onClick={ component.resetStep }
								className="c-btn c-btn--primary c-btn--extra
								u-margin-bottom-30">
								Revenir
							</button>

							<button type="button" onClick={ component.stopRenewal }
								className="c-btn c-btn--red c-btn--extra
								u-margin-bottom-30">
								Je confirme que je ne souhaite pas renouveler
								{ cancel_loader }
							</button>

						</div>

					</div>

				</div>
			);
		}

		let output =
		(
			<div className="partners-renewal__fields">

				<div className="o-content">

					<div className="partners-renewal__btns u-content-end
						u-full-width">

						<button type="button" onClick={ component.initiateCanceling }
							className="c-btn c-btn--red c-btn--extra
							u-margin-bottom-30">
							Je ne souhaite pas renouveler
						</button>

					</div>

					<div className="c-subtitle">
						<div className="c-subtitle__txt u-text-left">
							Votre visibilité WEB (Gratuit)
						</div>
					</div>

					<p className="partners-renewal__title u-margin-top-15">
						1. Vérification du contenu de votre fiche&nbsp;:
						{ ' ' }
						{ state.partner?.name }
					</p>

					<div className="partners-renewal__infos">
						{ component.getParnerInfos() }
					</div>

				</div>

				{ update_infos }

				{ discount_part }

				{ parts_3_4 }

				{ confirmation_cbs }

				<p>
					Pour toute question ou information&nbsp;: Pierre HARAMBOURE partenariats@e-synergies.fr -
					{ ' ' }
					<a href="tel:+33677801710">06 77 80 17 10</a>
				</p>

				{ getFormStatus(state.update_status) }

				<button type="button" onClick={ component.validate }
					className="c-btn c-btn--primary c-btn--extra">
					Confirmer mon renouvellement
					{ loader }
				</button>

			</div>
		);

		return output;
	}

	// eslint-disable-next-line react/no-unused-class-component-methods
	getParnerInfos = () =>
	{
		const component = this, props = this.props, state = this.state;

		const partner = state.partner;

		let place_label = '';

		if (partner.address_1)
		{
			let is_line_2_first = false;

			if (typeof partner.address_2 === 'string')
			{
				let line_2 = partner.address_2;

				is_line_2_first = ['Zone', 'ZI', 'ZA', 'Espace']
				.find(function (str)
				{
					return line_2.toLowerCase().indexOf(str.toLowerCase()) !== -1;
				});
			}

			if (is_line_2_first && partner.address_2)
			{
				place_label += partner.address_2 + ', ';
			}

			place_label += partner.address_1;

			if (!is_line_2_first && partner.address_2)
			{
				place_label += ', ' + partner.address_2;
			}

			place_label += partner.zip_code ? ', ' + partner.zip_code : '';

			if (!partner.zip_code) place_label += ',';

			place_label += partner.city ? ' ' + partner.city : '';
		}

		let links =
		[
			partner.linkedin,
			partner.facebook,
			partner.instagram,
			partner.website
		]
		.map(function (link, i)
		{
			if (!link) return link;

			if (link.indexOf('http') === -1)
			{
				if (i < 2)
				{
					link = 'https://' + link;
				}
				else
				{
					link = 'http://' + link;
				}
			}
			else if (link.indexOf('https') === -1 && i < 2)
			{
				link = link.replace('http', 'https');
			}

			return link;
		});

		let linkedin = links[0], facebook = links[1], instagram = links[2], website = links[3];
		let email   = partner.email, phone = partner.phone;

		if (linkedin)
		{
			linkedin =
			(
				<a className="c-model__social" href={ links[0] } rel="noreferrer"
					target="_blank">
					<LinkedinIcon className="o-svg-icon o-svg-icon--linkedin
						c-model__social-icon"
					/>
				</a>
			);
		}

		if (facebook)
		{
			facebook =
			(
				<a className="c-model__social" href={ links[1] } rel="noreferrer"
					target="_blank">
					<svg className="o-svg-icon o-svg-icon--facebook
						c-model__social-icon">
						<use xlinkHref="/images/icons.svg#svg-icon-facebook" />
					</svg>
				</a>
			);
		}

		if (instagram)
		{
			instagram =
			(
				<a className="c-model__social" href={ links[2] } rel="noreferrer"
					target="_blank">
					<svg className="o-svg-icon o-svg-icon--instagram
						c-model__social-icon">
						<use xlinkHref="/images/icons.svg#svg-icon-instagram" />
					</svg>
				</a>
			);
		}

		if (website)
		{
			website =
			(
				<a className="c-model__social" href={ links[3] } rel="noreferrer"
					target="_blank">
					<svg className="o-svg-icon o-svg-icon--website
						c-model__social-icon">
						<use xlinkHref="/images/icons.svg#svg-icon-website" />
					</svg>

					<div className="c-model__social-text">
						Site web&nbsp;:
						{
							' ' +
							website
							.replace('http://', '')
							.replace('https://', '')
							.replace('www.', '')
						}
					</div>
				</a>
			);
		}

		if (email)
		{
			email =
			(
				<div className="c-model__social">
					<svg className="o-svg-icon o-svg-icon--mail c-model__social-icon">
						<use xlinkHref="/images/icons.svg#svg-icon-mail" />
					</svg>

					<div className="c-model__social-text">
						E-mail&nbsp;:
						{
							' ' +
							email
							.replace('http://', '')
							.replace('https://', '')
							.replace('www.', '')
						}
					</div>
				</div>
			);
		}

		if (phone)
		{
			phone =
			(
				<div className="c-model__social">
					<svg className="o-svg-icon o-svg-icon--phone
						c-model__social-icon">
						<use xlinkHref="/images/icons.svg#svg-icon-phone" />
					</svg>

					<div className="c-model__social-text">
						Téléphone&nbsp;:
						{ ' ' + app.getSpacedPhoneNumber(phone) }
					</div>
				</div>
			);
		}

		let place;

		if (place_label)
		{
			place =
			(
				<div className="c-model__social-media u-margin-bottom-10">
					<svg className="o-svg-icon o-svg-icon--tracker
						c-model__places-icon">
						<use xlinkHref="/images/icons.svg#svg-icon-tracker" />
					</svg>
					{ place_label }
				</div>
			);
		}

		const content =
		(
			<div className="u-full-width">

				{ place }

				<div className="c-model__social-media">
					{ website }
				</div>

				<div className="c-model__social-media">
					{ email }
				</div>

				<div className="c-model__social-media">
					{ phone }
				</div>

				<div className="c-model__social-media">
					<div className="u-margin-right-10">
						Réseaux sociaux&nbsp;:
					</div>
					{ linkedin }
					{ facebook }
					{ instagram }
					{ !linkedin && !facebook && !instagram ? 'aucun' : undefined }
				</div>

				{
					partner.online_access === 'true' ?
					(
						<div className="partners-renewal__infos-item">
							Accès en ligne&nbsp;: oui.
						</div>
					)
					: undefined
				}

				{
					partner.online_access === 'true' ?
					(
						<span className="c-rendered-text"
							dangerouslySetInnerHTML={
							{ __html: partner.online_access_infos } }
						/>
					)
					: undefined
				}

				{
					partner.online_access_url ?
					(
						<div className="u-margin-top-10">

							{ partner.online_access_url }

						</div>
					)
					: undefined
				}

			</div>
		);

		return content;
	}
}
